import styled from '@emotion/styled';
import theme from '../theme';

const { breakpoints } = theme;

const InlineFlexButtonWrapper = styled.div`
  display: inline-flex;
  width: 100%;
  @media screen and (min-width: ${breakpoints.desktop}) {
    width: auto;
  }
  a {
    text-decoration: none;
    display: block;
    width: 100%;
  }
`;

export default InlineFlexButtonWrapper;
